import { jsx as s, jsxs as f } from "react/jsx-runtime";
import { c as l } from "../../../index-Cu0xwYjD.js";
import { forwardRef as m, useState as x } from "react";
import { DismissButton as B } from "../DismissButton/DismissButton.js";
import '../../../assets/Notification.css';const h = "_focusWrapper_m1h4b_4", N = "_notificationBox_m1h4b_8", T = "_success_m1h4b_18", v = "_warning_m1h4b_25", w = "_error_m1h4b_32", C = "_info_m1h4b_39", g = "_notificationContentBox_m1h4b_46", W = "_notificationTitleBox_m1h4b_51", j = "_dismissable_m1h4b_61", y = "_notificationTitle_m1h4b_51", i = {
  focusWrapper: h,
  notificationBox: N,
  success: T,
  warning: v,
  error: w,
  info: C,
  notificationContentBox: g,
  notificationTitleBox: W,
  dismissable: j,
  notificationTitle: y
}, I = m(
  ({
    id: t,
    title: n,
    children: o,
    variant: c = "info",
    dismissible: e,
    onDismiss: r,
    ariaLive: _ = "polite",
    ...d
  }, b) => {
    const [u, p] = x(!1);
    return u || !n && !o ? null : /* @__PURE__ */ s(
      "div",
      {
        "aria-live": _,
        className: i.focusWrapper,
        ref: b,
        tabIndex: -1,
        "aria-labelledby": n || o ? `${t}-title` : void 0,
        "data-testid": "nb-notification-focus-wrapper",
        id: t,
        ...d,
        children: /* @__PURE__ */ f(
          "div",
          {
            className: l(i.notificationBox, {
              [i[c]]: !!c
            }),
            children: [
              /* @__PURE__ */ f(
                "div",
                {
                  className: l(i.notificationTitleBox, {
                    [i.dismissable]: e
                  }),
                  children: [
                    /* @__PURE__ */ s("h2", { className: i.notificationTitle, id: `${t}-title`, children: n }),
                    e ? /* @__PURE__ */ s(
                      B,
                      {
                        onClick: () => {
                          p(!0), r && r();
                        },
                        "data-testid": "nb-notification-dismiss"
                      }
                    ) : null
                  ]
                }
              ),
              o ? /* @__PURE__ */ s(
                "div",
                {
                  className: i.notificationContentBox,
                  "data-testid": "el-notification-box",
                  children: o
                }
              ) : null
            ]
          }
        )
      }
    );
  }
), a = (t, n) => m(
  (o, c) => /* @__PURE__ */ s(
    I,
    {
      ariaLive: n,
      variant: t,
      ref: c,
      ...o
    }
  )
), E = a(
  "error",
  "assertive"
), R = a("info"), q = a("success"), z = a("warning");
export {
  E as ErrorNotification,
  R as InfoNotification,
  I as Notification,
  q as SuccessNotification,
  z as WarningNotification
};
